import numberInputStyles from './NumberInputCell.module.scss';
import textInputStyles from './TextInputCell.module.scss';

import clsx from 'clsx';

import {
  useNumberInput,
  UseNumberInputProps,
} from '@work4all/components/lib/input/number-input/use-number-input';
import { useNumberInputLocalePreset } from '@work4all/components/lib/input/number-input/use-number-input-locale-preset';
import { useNumberInputProps } from '@work4all/components/lib/input/number-input/use-number-input-props';

interface NumberInputCellProps
  extends Omit<UseNumberInputProps, 'thousandSeparator' | 'decimalSeparator'> {
  disabled?: boolean;
  hideZero?: boolean;
}

export const NumberInputCell = (props: NumberInputCellProps) => {
  const localeProps = useNumberInputLocalePreset();

  const { numberInputProps, otherProps } = useNumberInputProps({
    ...props,
    ...localeProps,
  });

  const { getInputProps, valueAsNumber } = useNumberInput(numberInputProps);

  const inputProps = getInputProps();
  return (
    <input
      className={clsx(textInputStyles.textInput, numberInputStyles.numberInput)}
      {...getInputProps()}
      {...otherProps}
      value={valueAsNumber === 0 && props.hideZero ? '' : inputProps.value}
    />
  );
};
